import usePermanentWidgets from "./usePermanentWidgets";

export default usePermanentWidgets;
